import {
  lastFullMonth,
  monthToDate,
  rangeProblem,
  todayInEastern,
  type CustomRange,
} from "../lib/date-windows";

/**
 * The From / To boxes behind every "Custom dates…" option — the review queue
 * and the survey report share this so the two can't drift. DP #36602.
 *
 * `summary` is the line under the boxes when the range is valid ("Reviews
 * written Sep 1 – Sep 30, 2026, Eastern time"); a bad range shows the problem
 * there instead, in words.
 */
export function CustomRangeFields({
  range,
  onChange,
  summary,
}: {
  range: CustomRange;
  onChange: (next: CustomRange) => void;
  summary: string;
}) {
  const problem = rangeProblem(range);
  const quick =
    "rounded-full bg-white px-2 py-0.5 text-[11px] font-medium text-slate-600 ring-1 ring-inset ring-slate-200 hover:bg-slate-100";
  const box = "rounded border border-slate-300 bg-white px-1.5 py-0.5 text-xs";
  return (
    <div className="rounded-lg border border-slate-200 bg-slate-50 px-3 py-2">
      <div className="flex flex-wrap items-center gap-2 text-xs text-slate-700">
        <label className="flex items-center gap-1">
          From
          <input
            type="date"
            value={range.from}
            min="2000-01-01"
            max={range.to || undefined}
            onChange={(e) => onChange({ ...range, from: e.target.value })}
            className={box}
          />
        </label>
        <label className="flex items-center gap-1">
          to
          <input
            type="date"
            value={range.to}
            min={range.from || "2000-01-01"}
            onChange={(e) => onChange({ ...range, to: e.target.value })}
            className={box}
          />
        </label>
        <button onClick={() => onChange(lastFullMonth(todayInEastern()))} className={quick}>
          Last month
        </button>
        <button onClick={() => onChange(monthToDate(todayInEastern()))} className={quick}>
          This month
        </button>
      </div>
      <div className="mt-1 text-[11px] text-slate-500">
        {problem ? <span className="font-medium text-rose-600">{problem}</span> : summary}
      </div>
    </div>
  );
}
